import { createSelector } from 'reselect';
import { selectAddressesDomain } from '../addresses/selectors';

export const GET_AUTOPARKS = 'autoparks/GET_AUTOPARKS';
export const getAutoparksAction = payload => ({
	type: GET_AUTOPARKS,
	payload,
});

export const SET_AUTOPARKS = 'autoparks/SET_AUTOPARKS';
export const setAutoparksAction = payload => ({
	type: SET_AUTOPARKS,
	payload,
});

export const SET_PAGINATION = 'autoparks/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});
export const getRawPaginationSelector = () => createSelector(selectAddressesDomain, ({ pagination }) => pagination);

export const SET_IS_AUTOPARKS_LOADING = 'autoparks/SET_IS_AUTOPARKS_LOADING';
export const setIsAutoparksLoadingAction = payload => ({
	type: SET_IS_AUTOPARKS_LOADING,
	payload,
});
export const SET_TABLE_SEARCH = 'autoparks/SET_TABLE_SEARCH';
export const setTableSearchAction = payload => ({
	type: SET_TABLE_SEARCH,
	payload,
});

export const RESET_STATE = 'autoparks/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
